import React from 'react';
import { ApprovalRequestsTable } from '../ApprovalRequestsTable/ApprovalRequestsTable';
import { mapApprovalRequests } from '../ApprovalRequestsTable/mappings';
import ServerError from '../../../../../components/ServerError';
import {
  AbsenceApprovalStatus,
  ApprovalRequestStatus,
  useAllApprovalRequestToMeQuery,
} from '../../../__generated__/graphql';

export const AllApprovalRequests: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { data, loading, error } = useAllApprovalRequestToMeQuery();

  if (error) {
    return <ServerError />;
  }
  const requests = mapApprovalRequests(data?.me.approvalRequests ?? []).filter(
    (request) => {
      if (request.absence) {
        if (
          request.approvalStatus === ApprovalRequestStatus.Pending &&
          request.absence.flair__Approval_Status__c !==
            AbsenceApprovalStatus.Pending
        ) {
          return false;
        }
      }
      return true;
    },
  );

  const filterOutWithoutAbsence = requests.filter((request) => {
    if (request.relatedRecordObjectName !== 'Absence') {
      return true;
    }
    return request.absence !== null;
  });

  return (
    <ApprovalRequestsTable
      requests={filterOutWithoutAbsence}
      loading={loading}
    />
  );
};
